// Deterministic $ROBBED "achievement card" renderer for Leaderboard Share.
// Pure canvas drawing (NO external images -> never taints the canvas, always toBlob-able).
// 100% local, no AI. Uses only PUBLIC leaderboard info passed in.

const roundRect = (ctx, x, y, w, h, r) => {
  ctx.beginPath();
  ctx.moveTo(x + r, y);
  ctx.arcTo(x + w, y, x + w, y + h, r);
  ctx.arcTo(x + w, y + h, x, y + h, r);
  ctx.arcTo(x, y + h, x, y, r);
  ctx.arcTo(x, y, x + w, y, r);
  ctx.closePath();
};

// Shrink font until the text fits maxW, then draw centered at (cx, y).
const fitCenter = (ctx, text, cx, y, maxW, size, weight = "900", fam = "'Arial Black', Impact, sans-serif") => {
  let s = size;
  do {
    ctx.font = `${weight} ${s}px ${fam}`;
    if (ctx.measureText(text).width <= maxW || s <= 22) break;
    s -= 2;
  } while (s > 22);
  ctx.fillText(text, cx, y);
};

export function renderRankCard(canvas, d) {
  const W = 1080, H = 1080;
  canvas.width = W; canvas.height = H;
  const ctx = canvas.getContext("2d");
  const neon = "#39FF20", gold = "#FFD700", cream = "#F5F0E6", dim = "#9a9a9a",
    ink = "#0b0b0d", ink2 = "#151517", silver = "#dcdcdc", bronze = "#cd7f32";
  const accent = d.rank === 1 ? gold : d.rank === 2 ? silver : d.rank === 3 ? bronze : neon;

  // background
  ctx.fillStyle = ink; ctx.fillRect(0, 0, W, H);
  // faint diagonal stripes
  ctx.save();
  ctx.globalAlpha = 0.05; ctx.strokeStyle = accent; ctx.lineWidth = 24;
  for (let i = -H; i < W; i += 74) { ctx.beginPath(); ctx.moveTo(i, 0); ctx.lineTo(i + H, H); ctx.stroke(); }
  ctx.restore();

  // frames
  ctx.strokeStyle = "#000"; ctx.lineWidth = 40; ctx.strokeRect(20, 20, W - 40, H - 40);
  ctx.strokeStyle = accent; ctx.lineWidth = 8; ctx.strokeRect(46, 46, W - 92, H - 92);

  const cx = W / 2;

  // top row wordmark + tag
  ctx.textAlign = "left"; ctx.textBaseline = "alphabetic";
  ctx.fillStyle = neon; ctx.font = "900 62px 'Arial Black', Impact, sans-serif";
  ctx.fillText("$ROBBED", 92, 152);
  ctx.textAlign = "right"; ctx.fillStyle = accent; ctx.font = "900 28px 'Arial Black', sans-serif";
  ctx.fillText("★ ACHIEVEMENT UNLOCKED", W - 92, 148);

  // sub label
  ctx.textAlign = "center"; ctx.fillStyle = dim; ctx.font = "800 32px 'Arial Black', sans-serif";
  ctx.fillText("RANKED ON THE CREW LEADERBOARD", cx, 232);

  // medal
  const ry = 420, rr = 150;
  ctx.beginPath(); ctx.arc(cx, ry, rr, 0, Math.PI * 2); ctx.fillStyle = ink2; ctx.fill();
  ctx.lineWidth = 16; ctx.strokeStyle = accent; ctx.stroke();
  ctx.lineWidth = 6; ctx.strokeStyle = "#000";
  ctx.beginPath(); ctx.arc(cx, ry, rr - 15, 0, Math.PI * 2); ctx.stroke();
  ctx.fillStyle = accent; ctx.textBaseline = "middle";
  ctx.font = "900 132px 'Arial Black', Impact, sans-serif";
  ctx.fillText(`#${d.rank}`, cx, ry + 4);
  ctx.textBaseline = "alphabetic";
  // "of N" under the medal
  ctx.fillStyle = dim; ctx.font = "700 26px 'Arial Black', sans-serif";
  ctx.fillText(`OF ${d.total} ROBBERS`, cx, 628);

  // display name
  ctx.fillStyle = cream;
  fitCenter(ctx, (d.name || "").toUpperCase(), cx, 704, W - 220, 66);

  // category
  ctx.fillStyle = accent; ctx.font = "800 32px 'Arial Black', sans-serif";
  ctx.fillText((d.catLabel || "").toUpperCase(), cx, 750);

  // big stat
  ctx.fillStyle = neon; ctx.font = "900 92px 'Arial Black', Impact, sans-serif";
  ctx.fillText(String(d.value), cx, 852);
  ctx.fillStyle = dim; ctx.font = "700 30px 'Arial Black', sans-serif";
  ctx.fillText(String(d.suffix || "").toUpperCase(), cx, 894);

  // level pill
  const pill = `ROB LVL ${d.level} · ${(d.levelName || "").toUpperCase()}`;
  ctx.font = "800 30px 'Arial Black', sans-serif";
  const pw = Math.min(W - 160, ctx.measureText(pill).width + 64);
  const px = cx - pw / 2, py = 924, ph = 56;
  roundRect(ctx, px, py, pw, ph, 12); ctx.fillStyle = "#000"; ctx.fill();
  ctx.lineWidth = 4; ctx.strokeStyle = accent; roundRect(ctx, px, py, pw, ph, 12); ctx.stroke();
  ctx.fillStyle = accent; ctx.textBaseline = "middle";
  ctx.fillText(pill, cx, py + ph / 2 + 2);
  ctx.textBaseline = "alphabetic";

  // footer
  ctx.fillStyle = cream; ctx.font = "900 28px 'Arial Black', Impact, sans-serif";
  ctx.fillText("THEY GOT RICH. WE GOT ROBBED.", cx, 1016);
}
